import { useEffect, useRef } from 'react'
import { useNavV3Gate } from '../../containers/nav-v3/useNavV3Gate'
import { useShouldAutoStartNavV3Onboarding } from './useNavV3OnboardingAccess'

type Props = {
  onAutoStart: () => void
  markSeen: () => void
}

// Effect-only component: fires the onboarding tour the first time v3 becomes
// enabled for this user/browser. Rendered as a sibling to the tour itself so
// it can run without re-mounting the provider's children on state changes.
//
// `useTdsNav` can flip to true without explicit user interaction (e.g. a
// Roulette toggle on `rt_ipp_nav_v3` lands while the user is on a different
// tab), so we react to `enabled` becoming true rather than to a click.
export const NavV3OnboardingAutoStart = ({ onAutoStart, markSeen }: Props) => {
  const { enabled } = useNavV3Gate()
  const shouldAutoStart = useShouldAutoStartNavV3Onboarding()
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (hasFiredRef.current) return
    if (!enabled) return
    if (!shouldAutoStart()) return
    hasFiredRef.current = true
    markSeen()
    onAutoStart()
  }, [enabled, shouldAutoStart, markSeen, onAutoStart])

  return null
}
